module.exports = __webpack_public_path__ + "img/help1-4-2.82500e4b.png";